export const A11yText = ({children}) =>{
  return (
    <span className="for-a11y">{children}</span>
  );
}
export const IconMoon = (
  {IconClassName,IconAltText}
  ) =>{
  return (
    <span aria-hidden={IconAltText ? false : true} className={IconClassName}>
      {
        IconAltText ? (
          <A11yText>{IconAltText}</A11yText>
        ) : (
          ""
        )
      }
    </span>
  );
}
IconMoon.defaultProps = {
  IconAltText:null,
  IconClassName:"icon-not_interested",
}